import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as updateConfigurationActions from '../../../actions/updateConfigurationActions';
import {ModalButton} from '../../../components/ModalButton';
import {GranitePicker} from '../components/GranitePicker';
import {isQuote} from '../../../services/restrictedConfiguration';
import { isConfigRequested } from "../../../services/configurationWarningChecks";
import { TranslationContext } from "../../../context/TranslationContext";
import {displayGranitConfigImage} from '../../../services/image.fct.service';
import { resetLazyImageQueue } from '../../../components/LazyImage';
import {gtmPro} from '../../../services/gtmPro';
import { getconfigprices } from '../../helpers/pricesHelper';

/**
 * ModalButton permettant de choisir le granite pour la semelle
 */
class FrameGranitePickerComponent extends Component {
  static contextType = TranslationContext;
  static propTypes = {
    monument: PropTypes.shape({
      graniteMain: PropTypes.string.isRequired,
    }).isRequired,
    frame: PropTypes.object,

  };

  state = {
    showImage: true,
  }

  modal;

  onSelectGranite = (reference) => {
    const selectedGranite = (this.props.granites || []).find((granite) => granite.reference === reference);
    gtmPro().clickGranite(selectedGranite || { reference }, 'frame');
    this.modal.close();
    this.setState({showImage: false}, () => {
      if(this.props.monument.kind === 'SEM'){
        this.props.actions.updateGraniteMonument(reference);
      }
      this.props.actions.updateGraniteFrame(reference);
      setTimeout(() => {
        this.setState({showImage: true});
      }, 1000);
    });
  };

   onModalClose = () =>{
      resetLazyImageQueue();
      this.setState({showImage: false}, () => {
  
        setTimeout(() => {
          this.setState({showImage: true})
        }, 1000);
      })
    }

  // Génére l'url de l'image de prévisualisation 3D de la semelle
  // dans un granit suggéré.
  makePreviewUrl = (graniteRef)=> {
    const {monument, frame, configuration} = this.props;
    // return imgs.configuration.monument.iso.thumbnail({
    //   monument,
    //   frame: Object.assign({}, frame, {granite: graniteRef})
    // }, {
    //   excludeDefaultPattern: true
    // })
    return displayGranitConfigImage(configuration,
      monument.graniteMain,
      false,
      monument.graniteSecondary,
      "thumbnail",
      false,
      0,
      0,
      graniteRef,
      0,
      0)
  };

  handleGranitsClick = () => {
    let gtmName = "extranet.config3d.config3d_granit_button_frame";
    gtmPro().ctaOfConfiguration(
      {
        name: gtmName,
        category: "configurateur",
        subcategory: "Granit",
        type: "cta",
        from: "left"
      },
      {template:"configurateur", subtemplate:"granits"},
      {},
      "partner",
      "product",
      "user",
      "page"
    );
  };

  render() {
    const t = this.context;
    const {frame} = this.props;
    const hasFrame = frame && frame.mode;
    const disabled = !hasFrame || isQuote(this.props.configuration) || isConfigRequested();

    const buttonContent = t("config3d_granit_button_frame") || "Semelle";
    return (
      <div className={"btn-wrapper"}>
        <ModalButton ref={(_modal) => this.modal = _modal}
                    buttonContent={buttonContent}
                    buttonIcon="frame-icon"
                    className="FrameGranitePickerPopupModal buttonModal background-page"
                    buttonClassName={`btn-config-secondary text-dark config-button-background ${!disabled && 'config-button-hover'}`}
                    overlayClassName="FrameGranitePickerPopupModalOverlay"
                    disabled={disabled}
                    toggleSteps={this.props.toggleSteps}
                    launchIntro={this.props.launchIntro}
                    modalName={this.props.modalName}
                    onClick={() => this.handleGranitsClick()}
                    onModalClose={this.onModalClose}
                    >
          {this.state.showImage &&
          <GranitePicker
            currentGraniteRef={frame && frame.granite}
            onPickGraniteRef={this.onSelectGranite}
            suggestionImageURL={this.makePreviewUrl}
            title={ t("config3d_granit_modal_frame_title") || "Choisissez un granit à appliquer sur la semelle" }
            type="frame" />
          }
        </ModalButton>
      </div>
    )
  }
}

export const FrameGranitePicker = connect((state) => ({
    configuration: state.configurator.current.configuration,
    monument: state.configurator.current.configuration.monument,
    frame: state.configurator.current.configuration.frame,
  granites: state.configurator.current.options.granites,
  }),
  (dispatch) => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch)
  })
)(FrameGranitePickerComponent);
